import { LoginComponent } from './login.component';
import { Route } from '@angular/router';

export const LoginRoutes: Route[] = [
 // { path: 'login',  component: LoginComponent },
  { path: 'labviewer/login', component: LoginComponent },
 // { path: 'labviewer',  redirectTo: '/labviewer/login', pathMatch: 'full'},
  { path: '',   redirectTo: '/labviewer/login', pathMatch: 'full' }, // redirect to 
];
